export const categories = [
  {
    id: 'fermented',
    name: '发酵黄油',
    slug: 'fermented-butter',
    description: '采用传统发酵工艺，乳酸菌发酵赋予黄油独特的乳酸风味，口感醇厚细腻，层次丰富，是烘焙与烹饪的上乘之选。',
    icon: 'ri-microscope-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20fermented%20cultured%20butter%20on%20a%20wooden%20board%20with%20fresh%20herbs%2C%20warm%20golden%20lighting%2C%20artisanal%20food%20photography%2C%20cream%20colored%20background%2C%20soft%20natural%20light%2C%20rustic%20elegant%20style%2C%20high%20detail%2C%20gourmet%20presentation&width=800&height=600&seq=cat-fermented&orientation=landscape',
  },
  {
    id: 'unsalted',
    name: '无盐黄油',
    slug: 'unsalted-butter',
    description: '纯正乳脂制成，不含盐分，奶香纯正浓郁。适合烘焙蛋糕、曲奇等甜品，可自由控制配方咸度，是专业烘焙师的首选。',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Unsalted%20pure%20cream%20butter%20block%20on%20marble%20surface%2C%20fresh%20dairy%20product%2C%20warm%20cream%20background%2C%20soft%20natural%20side%20lighting%2C%20clean%20minimalist%20food%20photography%2C%20high%20detail%2C%20elegant%20presentation&width=800&height=600&seq=cat-unsalted&orientation=landscape',
  },
  {
    id: 'animal',
    name: '动物黄油',
    slug: 'animal-butter',
    description: '采用优质牛乳提炼，天然动物脂肪带来浓郁奶香和丝滑口感。适用于煎烤、涂抹面包及各类西式料理，美味与营养兼备。',
    icon: 'ri-cup-line',
    image: 'https://readdy.ai/api/search-image?query=Rich%20creamy%20animal%20butter%20from%20grass%20fed%20cows%20on%20rustic%20wooden%20table%2C%20warm%20golden%20sunlight%2C%20dairy%20farm%20aesthetic%2C%20cream%20colored%20backdrop%2C%20gourmet%20food%20photography%2C%20high%20detail%2C%20natural%20texture&width=800&height=600&seq=cat-animal&orientation=landscape',
  },
  {
    id: 'imported',
    name: '进口黄油',
    slug: 'imported-butter',
    description: '严选法国、新西兰、丹麦等全球优质产区的黄油品牌，原装进口，品质溯源。每一块都承载着当地百年乳制品传统工艺。',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20imported%20European%20butter%20collection%20from%20France%20and%20New%20Zealand%2C%20elegant%20packaging%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20luxury%20food%20photography%2C%20high%20detail%2C%20sophisticated%20presentation&width=800&height=600&seq=cat-imported&orientation=landscape',
  },
  {
    id: 'organic',
    name: '有机黄油',
    slug: 'organic-butter',
    description: '源自有机牧场，奶牛天然放牧，无农药残留，不添加人工激素。通过国际有机认证，健康安全，是品质生活的理想之选。',
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=Organic%20butter%20from%20free%20range%20cows%20on%20ceramic%20plate%2C%20green%20pasture%20background%2C%20warm%20natural%20lighting%2C%20rustic%20farmhouse%20aesthetic%2C%20clean%20food%20photography%2C%20high%20detail%2C%20earthy%20tones&width=800&height=600&seq=cat-organic&orientation=landscape',
  },
];

export const products = [
  {
    id: 1,
    name: '法兰西发酵黄油卷',
    category: 'fermented',
    price: 68,
    originalPrice: 88,
    unit: '200g',
    origin: '法国',
    brand: 'Président',
    rating: 4.9,
    sales: 3256,
    tags: ['发酵', '进口', '热销'],
    image: 'https://readdy.ai/api/search-image?query=Premium%20French%20fermented%20cultured%20butter%20roll%20in%20gold%20foil%20wrapping%2C%20cream%20background%2C%20warm%20soft%20lighting%2C%20elegant%20product%20photography%2C%20high%20detail%2C%20gourmet%20food%20presentation&width=600&height=600&seq=prod-1&orientation=squarish',
    description: '法国原装进口，采用传统乳酸菌发酵工艺，72小时低温熟成，奶香浓郁，口感细腻丝滑，是制作法式可颂的必备原料。',
  },
  {
    id: 2,
    name: '新西兰无盐动物黄油',
    category: 'unsalted',
    price: 45,
    originalPrice: 58,
    unit: '227g',
    origin: '新西兰',
    brand: 'Anchor',
    rating: 4.8,
    sales: 5821,
    tags: ['无盐', '动物黄油', '爆款'],
    image: 'https://readdy.ai/api/search-image?query=New%20Zealand%20Anchor%20unsalted%20butter%20block%20on%20white%20surface%2C%20cream%20background%2C%20clean%20bright%20lighting%2C%20product%20photography%2C%20high%20detail%2C%20minimalist%20style&width=600&height=600&seq=prod-2&orientation=squarish',
    description: '新西兰纯净牧场奶源，天然牧草喂养，无添加盐分，纯粹乳脂醇香。适合烘焙蛋糕、饼干及各类甜品制作。',
  },
  {
    id: 3,
    name: '丹麦有机发酵黄油',
    category: 'organic',
    price: 98,
    originalPrice: 128,
    unit: '250g',
    origin: '丹麦',
    brand: 'Lurpak',
    rating: 4.9,
    sales: 1892,
    tags: ['有机', '发酵', '丹麦'],
    image: 'https://readdy.ai/api/search-image?query=Danish%20Lurpak%20organic%20butter%20in%20silver%20packaging%2C%20cream%20background%2C%20warm%20studio%20lighting%2C%20elegant%20product%20photography%2C%20high%20detail%2C%20luxury%20food%20styling&width=600&height=600&seq=prod-3&orientation=squarish',
    description: '丹麦有机牧场认证，奶牛全年户外放养。乳酸菌自然发酵，富含Omega-3，口感层次丰富，是健康与美味的完美结合。',
  },
  {
    id: 4,
    name: '澳洲草饲动物黄油',
    category: 'animal',
    price: 55,
    originalPrice: 69,
    unit: '250g',
    origin: '澳大利亚',
    brand: 'Westgold',
    rating: 4.7,
    sales: 4105,
    tags: ['动物黄油', '草饲', '澳洲'],
    image: 'https://readdy.ai/api/search-image?query=Australian%20grass%20fed%20butter%20in%20golden%20wrapping%2C%20cream%20background%2C%20warm%20lighting%2C%20clean%20product%20photography%2C%20high%20detail%2C%20natural%20food%20styling&width=600&height=600&seq=prod-4&orientation=squarish',
    description: '澳洲广袤牧场草饲奶牛，天然放养环境产出高品质牛乳。黄油色泽金黄，奶香纯正，煎烤涂抹皆宜。',
  },
  {
    id: 5,
    name: '比利时发酵黄油片',
    category: 'fermented',
    price: 75,
    originalPrice: 95,
    unit: '500g',
    origin: '比利时',
    brand: 'Corman',
    rating: 4.8,
    sales: 2134,
    tags: ['发酵', '进口', '大包装'],
    image: 'https://readdy.ai/api/search-image?query=Belgian%20butter%20sheet%20for%20baking%20in%20professional%20packaging%2C%20cream%20background%2C%20soft%20studio%20lighting%2C%20product%20photography%2C%20high%20detail%2C%20clean%20professional%20style&width=600&height=600&seq=prod-5&orientation=squarish',
    description: '比利时专业烘焙黄油片，专为千层酥皮和可颂设计。高熔点特性，延展性极佳，层次分明，是烘焙师的秘密武器。',
  },
  {
    id: 6,
    name: '内蒙古无盐黄油块',
    category: 'unsalted',
    price: 32,
    originalPrice: 42,
    unit: '200g',
    origin: '中国',
    brand: '伊利',
    rating: 4.6,
    sales: 8934,
    tags: ['无盐', '国产', '性价比'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20Inner%20Mongolia%20butter%20block%20in%20simple%20packaging%2C%20cream%20background%2C%20clean%20lighting%2C%20product%20photography%2C%20high%20detail%2C%20natural%20style&width=600&height=600&seq=prod-6&orientation=squarish',
    description: '内蒙古黄金奶源带优质牛乳制成，零添加盐分，奶香浓郁纯正。国产高品质黄油代表，性价比极高。',
  },
  {
    id: 7,
    name: '法国诺曼底发酵黄油',
    category: 'fermented',
    price: 128,
    originalPrice: 158,
    unit: '250g',
    origin: '法国',
    brand: 'Isigny',
    rating: 5.0,
    sales: 987,
    tags: ['发酵', 'AOP认证', '顶级'],
    image: 'https://readdy.ai/api/search-image?query=Premium%20French%20Normandy%20AOP%20butter%20in%20elegant%20packaging%2C%20cream%20background%2C%20warm%20luxury%20lighting%2C%20high%20end%20product%20photography%2C%20high%20detail%2C%20gourmet%20style&width=600&height=600&seq=prod-7&orientation=squarish',
    description: '法国AOP原产地认证，诺曼底黄金奶源。传统木桶搅拌工艺，富含矿物质的海盐草饲养牛乳，口感无与伦比。',
  },
  {
    id: 8,
    name: '荷兰菲仕兰动物黄油',
    category: 'animal',
    price: 42,
    originalPrice: 55,
    unit: '250g',
    origin: '荷兰',
    brand: 'FrieslandCampina',
    rating: 4.7,
    sales: 3678,
    tags: ['动物黄油', '进口', '日常'],
    image: 'https://readdy.ai/api/search-image?query=Dutch%20butter%20block%20in%20classic%20blue%20and%20white%20packaging%2C%20cream%20background%2C%20clean%20lighting%2C%20product%20photography%2C%20high%20detail%2C%20traditional%20style&width=600&height=600&seq=prod-8&orientation=squarish',
    description: '荷兰百年乳企出品，荷兰郁金香牧场优质奶源。奶香均衡温和，日常涂抹面包、烹饪调味的上佳之选。',
  },
];

export const featuredProductIds = [1, 2, 3, 4, 5, 6, 7, 8];